import type { PopulatedThreshold, Threshold } from 'flow/store/engine/types';
import type { RuleBuilderEditMode } from './types';

export function isDisabled(editMode: RuleBuilderEditMode) {
  return editMode === 'disabled';
}

export function isEditable(editMode: RuleBuilderEditMode) {
  return editMode === 'editable';
}

export function getIsPreview(
  editMode: RuleBuilderEditMode,
  threshold: PopulatedThreshold,
  activeSubEditorId: Threshold['publicId'] | null,
) {
  if (threshold.isPreview) return true;

  if (!isDisabled(editMode)) return false;

  if (threshold.publicId === activeSubEditorId) {
    return false;
  }

  return true;
}
